import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import FilterWordsActions from 'actions/triggers/FilterWordsActions';
import FilterWordsStore from 'stores/triggers/FilterWordsStore';
import KeywordTopicSelectionContainer from './KeywordTopicSelectionContainer';
import {CallConditionType, SpeakerCondition} from 'records/CallTrigger';

@connectToStores
export default class KeywordTopicSelectionViewRow extends React.Component {
  constructor(props) {
    super(props);

    this.showSelection = this.showSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);

    this.state = {
      selectionVisible: false,
      previousContext: null,
    };
  }

  static getStores() {
    return [FilterWordsStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    if (context && context.type) {
      const filterWords = FilterWordsStore.getState().filterWords;
      const filterWord = filterWords.find(w => w.id === context.keywordTopicPhrase.filterWordId);
      const keyword = context.keywordTopicPhrase.keyword;
      return {
        filterWord,
        keyword,
      };
    }

    return null;
  }

  componentDidMount() {
    const filterWordsLoaded = FilterWordsStore.getState().filterWordsLoaded;
    if (!filterWordsLoaded) {
      FilterWordsActions.fetchAll.defer();
    }
    if (this.props.context && this.props.context.type) {
      this.setState({previousContext: this.props.context});
    }
  }

  showSelection() {
    this.setState({
      selectionVisible: true,
    });
  }

  closeSelection() {
    this.setState({
      selectionVisible: false,
    });
    this.state.previousContext && this.props.updateContext(this.state.previousContext);
  }

  saveSelection(context, close = true) {
    if (close) {
      this.setState({
        selectionVisible: false,
        previousContext: context,
      });
    }
    this.props.updateContext(context);
  }

  renderMentionedAt(range) {
    if (range.start === 0) {
      return `before ${range.end}%`;
    } else if (range.end === 100) {
      return `after ${range.start}%`;
    } else {
      return `between ${range.start}% to ${range.end}%`;
    }
  }
  renderDescription(context, topic, keyword, defaultText, label) {
    if (context.type === undefined) {
      return <span>{defaultText}</span>;
    }
    const wordString = (topic && topic.word) || keyword || '[SELECT TOPIC]';
    return (
      <span>
        <span className="condition-action" onClick={this.showSelection}>
          {label}
          {context.speakerType === SpeakerCondition.EXTERNAL && 'the contacts '}
          {context.speakerType === SpeakerCondition.INTERNAL && `the caller's party `}
          {context.speakerType === SpeakerCondition.CALLER && 'the caller '}
          {!context.speakerType && (context.negated ? 'neither party ' : 'either party ')}
          {topic
            ? context.negated && context.speakerType
              ? 'did not discuss '
              : 'discussed '
            : context.negated && context.speakerType
            ? 'did not say '
            : 'said '}
          "{wordString}"
          {context.type === CallConditionType.MENTIONED_AT_LEAST_ONCE && ' anywhere within call'}
          {context.type === CallConditionType.MENTIONED_AT &&
            ` at any time ${this.renderMentionedAt(context.range)} of the call duration`}
        </span>
      </span>
    );
  }

  render() {
    // filterWord is always a topic. keywords are passed in as the value of keyword (a string).
    const {context, filterWord, keyword, defaultText, label} = this.props;
    return (
      <div>
        {this.renderDescription(context, filterWord, keyword, defaultText, label)}
        {this.state.selectionVisible && (
          <div className="create-rule-popout edit-popout">
            <KeywordTopicSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={context => this.saveSelection(context, false)}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
              condition={context}
            />
          </div>
        )}
      </div>
    );
  }
}
